import { Controller } from 'stimulus'
import { haptics } from '~/common/helpers/haptics'
import { updateQuantity } from '~/site/pages/cart/common'

export default class extends Controller {
  updateQuantity(e) {
    if (e.target.value) {
      updateQuantity()
      haptics.tick()
    }
  }
}
